<ng-container
  *ngIf="isLoaded">
<router-outlet></router-outlet>
</ng-container>


